/* mo-collection.js — Mollaoglou koleksiyon sayfası (filtre + sonsuz kaydırma + hızlı sepet) */
(function () {
  'use strict';
  var root = document.getElementById('MoCol');
  if (!root) return;
  root.classList.add('is-js');

  var SID = root.getAttribute('data-section-id');
  var BASE = root.getAttribute('data-url');
  var form = document.getElementById('MoColForm');
  var io = null;
  var loadingNext = false;
  var debT = null;

  function $(s, c) { return (c || root).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }

  function sectionUrl(url) {
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', SID);
    return u.toString();
  }

  /* ---------- section rendering: filtre / sıralama yenileme ---------- */
  /* Odak koruması (2026-08-05): innerHTML değişince odaktaki kutu yok oluyor ve
     odak <body>'ye düşüyordu — klavye/ekran okuyucu kullanıcısı her filtrede
     listenin başına dönüyordu. Yenilemeden önce odaklı öğenin kimliğini
     (name+value ya da data-mo-sort) not alıp sonra aynısına geri veriyoruz. */
  /* 2026-08-06 duzeltmesi: canli olcumde filtre uygulayinca odak <body>'ye dusuyordu.
     Sebep: focusKey yalnizca `name` ozniteligi OLAN ogeleri hatirliyordu. Filtre onay
     kutularinin name'i var (filter.v.availability gibi) ama AYNI name'i paylasan birden
     cok kutu oldugu icin `val` esleşmesi sarttı; deger karsilastirmasi da checkbox'ta
     `el.value` uzerinden yapiliyordu ve dogru satiri her zaman bulamiyordu. Ayrica
     marka arama kutusunun (data-fsearch) name'i hic yok — o hic hatirlanmiyordu.
     Artik once kararli bir kimlik (data-mo-fkey ya da id) deneniyor, sonra name+value,
     en sonda arama kutusu. */
  function focusKey() {
    var el = document.activeElement;
    if (!el || !root.contains(el)) return null;
    if (el.hasAttribute('data-mo-sort')) return { sel: '[data-mo-sort]' };
    if (el.hasAttribute('data-fsearch')) return { sel: '[data-fsearch]', text: el.value };
    if (el.id) {
      return { sel: '#' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) };
    }
    if (el.name) {
      return { sel: '[name="' + (window.CSS && CSS.escape ? CSS.escape(el.name) : el.name) + '"]', val: el.value };
    }
    return null;
  }
  function restoreFocus(k) {
    if (!k) return;
    var list = $all(k.sel);
    for (var i = 0; i < list.length; i++) {
      if (k.val === undefined || list[i].value === k.val) {
        try { list[i].focus({ preventScroll: true }); } catch (e) { list[i].focus(); }
        /* Arama kutusuysa yazilan metni de geri koy ve suzmeyi yeniden calistir —
           yoksa kullanicinin yazdigi «Bosch» siliniyor ve 60+ marka geri geliyordu. */
        if (k.text !== undefined) {
          list[i].value = k.text;
          list[i].dispatchEvent(new Event('input', { bubbles: true }));
        }
        return;
      }
    }
  }

  function refresh(url, push) {
    root.classList.add('is-loading');
    var fk = focusKey();
    fetch(sectionUrl(url))
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['MoColMain', 'MoColForm'].forEach(function (id) {
          var src = doc.getElementById(id);
          var dst = document.getElementById(id);
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        restoreFocus(fk);
        var c = doc.querySelector('.mo-col__seen [data-mo-count]') || doc.querySelector('[data-mo-count]');
        if (c && parseInt(c.textContent, 10) > 0) {
          $all('[data-mo-count]').forEach(function (el) { el.textContent = c.textContent; });
          /* Ekran okuyucuya duyur (2026-08-06). Bu dugum #MoColMain'in DISINDA ve
             yenilemede silinmiyor, o yuzden aria-live gercekten seslendiriliyor. */
          var live = root.querySelector('[data-mo-live]');
          if (live) live.textContent = c.textContent + ' προϊόντα';
        }
        if (push) history.pushState({ moCol: 1 }, '', url);
        root.classList.remove('is-loading');
        initGrid();
        var head = $('.mo-col__head');
        if (head && head.getBoundingClientRect().top < -10) head.scrollIntoView();
      })
      .catch(function () { location.href = url; });
  }

  function formUrl() {
    var sp = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      if (String(v).length) sp.append(k, v);
    });
    var qs = sp.toString();
    return BASE + (qs ? '?' + qs : '');
  }

  function applyFilters() {
    clearTimeout(debT);
    debT = setTimeout(function () { refresh(formUrl(), true); }, 300);
  }

  /* ---------- delegasyon: change / input / click / submit ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-fsearch')) return;
    if (t.hasAttribute('data-mo-sort') || (form && form.contains(t))) applyFilters();
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.hasAttribute('data-fsearch')) return;
    var q = t.value.trim().toLowerCase();
    var body = t.closest('.mo-col__fbody');
    if (!body) return;
    $all('.mo-col__chk', body).forEach(function (l) {
      l.hidden = !!q && (l.getAttribute('data-name') || '').indexOf(q) === -1;
    });
  });

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(debT);
    refresh(formUrl(), true);
    closeSheet();
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mo-link]');
    if (a && root.contains(a)) { e.preventDefault(); refresh(a.getAttribute('href'), true); return; }
    var add = e.target.closest('[data-mo-add]');
    if (add && root.contains(add)) { e.preventDefault(); quickAdd(add); return; }
    if (e.target.closest('[data-mo-open-sheet]')) { openSheet(); return; }
    if (e.target.closest('[data-mo-close-sheet]')) { closeSheet(); }
  });

  window.addEventListener('popstate', function () { refresh(location.href, false); });

  /* ---------- hızlı sepete ekleme ---------- */
  function quickAdd(btn) {
    var f = btn.closest('form');
    if (!f || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) return;
        btn.classList.add('is-done');
        var lbl = btn.querySelector('[data-mo-add-label]');
        var orig = lbl ? lbl.textContent : '';
        if (lbl) lbl.textContent = '✓ Προστέθηκε';
        setTimeout(function () {
          btn.classList.remove('is-done');
          if (lbl) lbl.textContent = orig;
        }, 2000);
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.mo-cart .mo-badge,[data-cart-count],.cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function () {});
        document.dispatchEvent(new CustomEvent('mo:cart:added'));
      })
      .catch(function () { btn.classList.remove('is-busy'); });
  }

  /* ---------- sonsuz kaydırma ---------- */
  function cardCount() { return $all('[data-mo-grid] .mo-card').length; }

  /* iskelet kartlar (Cila H3): yükleme sırasında 4 placeholder — reduced-motion'da sabit gri */
  function addSkels() {
    var grid = $('[data-mo-grid]');
    var arr = [];
    if (!grid) return arr;
    for (var i = 0; i < 4; i++) {
      var d = document.createElement('div');
      d.className = 'mo-card--skel';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<div class="sk-media"></div><div class="sk-body"><div class="sk-line"></div><div class="sk-line sk-line--w60"></div><div class="sk-line sk-line--w35"></div><div class="sk-btn"></div></div>';
      grid.appendChild(d);
      arr.push(d);
    }
    return arr;
  }
  function rmSkels(arr) {
    arr.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    arr.length = 0;
  }

  function updateStatus() {
    var isc = $('[data-mo-iscroll]');
    var grid = $('[data-mo-grid]');
    if (!isc || !grid) return;
    var total = parseInt(grid.getAttribute('data-total'), 10) || 0;
    /* Sayaç ile ızgara asla çelişmesin: data-total = paginate.items (tek doğru kaynak) */
    if (total > 0) $all('[data-mo-count]').forEach(function (el) { el.textContent = total; });
    var n = cardCount();
    var s = $('[data-mo-seen]');
    if (s) s.textContent = n;
    var m = $('[data-mo-meter]');
    if (m) m.style.width = (total ? Math.max(2, Math.min(100, (n / total) * 100)) : 100).toFixed(1) + '%';
    if (!$('[data-mo-next]')) isc.classList.add('is-done');
  }

  function loadNext() {
    var nextA = $('[data-mo-next]');
    if (loadingNext || !nextA) return;
    loadingNext = true;
    var isc = $('[data-mo-iscroll]');
    if (isc) isc.classList.add('is-loading');
    var skels = addSkels();
    var url = nextA.getAttribute('href');
    fetch(sectionUrl(url))
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-mo-grid]');
        var frag = document.createDocumentFragment();
        var news = [];
        doc.querySelectorAll('[data-mo-grid] .mo-card').forEach(function (card) {
          var el = document.importNode(card, true);
          el.classList.add('is-new');
          frag.appendChild(el);
          news.push(el);
        });
        rmSkels(skels);
        if (grid) grid.appendChild(frag);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            news.forEach(function (el) { el.classList.add('is-in'); });
          });
        });
        var pOld = $('[data-mo-pag]');
        var pNew = doc.querySelector('[data-mo-pag]');
        if (pOld) pOld.innerHTML = pNew ? pNew.innerHTML : '';
        /* 2026-08-06: burada `history.replaceState(..., url)` vardi ve adresi ?page=N
           yapiyordu. Musteri 4 tur kaydirip (96 urun) bir urune giriyor, sonra geri
           tusuna basinca adres ?page=4 oldugu icin sunucu yalnizca 73-96. urunleri
           basiyordu — gordugu ilk 72 urun yok oluyordu ve kaydirma konumu anlamsiz
           bir yere dusuyordu. Satir silindi: adres temiz kaliyor, geri donus
           koleksiyonun basina dusuyor ve tarayicinin bfcache'i calisabiliyor.
           :64'teki pushState (filtre/siralama) ve :121'deki popstate bundan bagimsiz. */
        loadingNext = false;
        if (isc) isc.classList.remove('is-loading');
        updateStatus();
        if (!$('[data-mo-next]')) {
          if (io) io.disconnect();
          if (isc) isc.classList.add('is-done');
        } else {
          var sent = $('[data-mo-sentinel]');
          if (sent && sent.getBoundingClientRect().top <= innerHeight + 700) loadNext();
        }
      })
      .catch(function () {
        rmSkels(skels);
        loadingNext = false;
        if (isc) isc.classList.remove('is-loading');
      });
  }

  function initGrid() {
    if (io) { io.disconnect(); io = null; }
    loadingNext = false;
    updateStatus();
    var sent = $('[data-mo-sentinel]');
    if (!sent || !$('[data-mo-next]')) return;
    if (!('IntersectionObserver' in window)) return; /* fallback: klasik sayfalama linki */
    io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) loadNext();
    }, { rootMargin: '700px 0px' });
    io.observe(sent);
  }

  /* ---------- mobil bottom-sheet ---------- */
  var lastFocus = null;
  function sheetEls() {
    return { aside: $('.mo-col__filters'), bd: $('.mo-col__backdrop') };
  }
  function openSheet() {
    var s = sheetEls();
    if (!s.aside) return;
    lastFocus = document.activeElement;
    s.aside.classList.add('is-open');
    s.aside.setAttribute('role', 'dialog');
    s.aside.setAttribute('aria-modal', 'true');
    if (s.bd) { s.bd.hidden = false; requestAnimationFrame(function () { s.bd.classList.add('is-show'); }); }
    document.body.style.overflow = 'hidden';
    var x = $('.mo-col__sheet-x', s.aside);
    setTimeout(function () { if (x) x.focus(); }, 80);
  }
  function closeSheet() {
    var s = sheetEls();
    if (!s.aside || !s.aside.classList.contains('is-open')) return;
    s.aside.classList.remove('is-open');
    s.aside.removeAttribute('role');
    s.aside.removeAttribute('aria-modal');
    if (s.bd) { s.bd.classList.remove('is-show'); setTimeout(function () { s.bd.hidden = true; }, 240); }
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }
  /* iOS: body overflow:hidden yetmez — backdrop üstünde parmak kaydırınca arka sayfa kayar */
  document.addEventListener('touchmove', function (e) {
    if (e.target.closest && e.target.closest('.mo-col__backdrop')) e.preventDefault();
  }, { passive: false });
  document.addEventListener('keydown', function (e) {
    var s = sheetEls();
    var open = s.aside && s.aside.classList.contains('is-open');
    if (e.key === 'Escape' && open) { e.preventDefault(); closeSheet(); return; }
    if (e.key === 'Tab' && open) {
      var f = $all('button:not([disabled]),a[href],input:not([disabled]),select,summary', s.aside).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  initGrid();
})();
